<template>
  <div>
    <v-card class="white rounded-lg">
      <v-card-title class="white--text secondary">
        <v-img class="ml-3" src="/img/icons/done_dark.svg" max-height="35" max-width="35"></v-img>
        برای راه اندازی سامانه مراحل زیر را طی کنید
      </v-card-title>
      <v-card-text class="pt-5">
        <div @click="bankDialog = true" class="ml-10 mr-10 mt-5">
          <v-banner :class="(user.set_up.bank)?'success--text':'secondary--text'" class="cursor-pointer rounded-lg mt-5"
                    style="font-size: larger; font-weight: bold">
            <v-avatar
                slot="icon"
                class="white--text"
                :color="(user.set_up.bank)?'success':'error'"
                size="25"
            >
              <v-icon v-if="!user.set_up.bank" color="white">
                fa-times
              </v-icon>
              <v-icon v-else color="white">
                fa-check
              </v-icon>
            </v-avatar>
            تعریف بانک و سایر حساب های خزانه
          </v-banner>
        </div>
        <div @click="personDialog = true" class="ml-10 mr-10">
          <v-banner :class="(user.set_up.person)?'success--text':'secondary--text'" class="cursor-pointer rounded-lg mt-5"
                    style="font-size: larger; font-weight: bold">
            <v-avatar
                slot="icon"
                class="white--text"
                :color="(user.set_up.person)?'success':'error'"
                size="25"
            >
              <v-icon v-if="!user.set_up.person" color="white">
                fa-times
              </v-icon>
              <v-icon v-else color="white">
                fa-check
              </v-icon>

            </v-avatar>
            تعریف اشخاص و جاری شرکا
          </v-banner>
        </div>
        <div @click="wareDialog = true" class="ml-10 mr-10">
          <v-banner :class="(user.set_up.ware)?'success--text':'secondary--text'" class="cursor-pointer rounded-lg mt-5"
                    style="font-size: larger; font-weight: bold">
            <v-avatar
                slot="icon"
                class="white--text"
                :color="(user.set_up.ware)?'success':'error'"
                size="25"
            >
              <v-icon v-if="!user.set_up.ware" color="white">
                fa-times
              </v-icon>
              <v-icon v-else color="white">
                fa-check
              </v-icon>

            </v-avatar>
            تعریف کالا
          </v-banner>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="bankDialog"
        class="rounded-lg"
        persistent
        max-width="90%"
    >
      <v-card class="rounded-lg">
        <v-card-text>
          <v-tabs class="rounded-lg white--text"
                  background-color="lightSecondary" color="primary">
            <v-tab class="white--text mr-2" active-class="secondary mr-2">
              <span> بانک</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> کارتخوان</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> درگاه بانکی</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> صندوق</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> تنخواه گردان</span>
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn icon fab color="white" class="mt-1 ml-2" @click="closeDialog('bank')">
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="b"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="s"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="g"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="d"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="i"></accounts>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="personDialog"
        class="rounded-lg"
        persistent
        max-width="90%"
    >
      <v-card class="rounded-lg">
        <v-card-text>
          <v-tabs class="rounded-lg white--text"
                  background-color="lightSecondary" color="primary">
            <v-tab class="white--text mr-2" active-class="secondary mr-2">
              <span> اشخاص</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> جاری شرکا دریافنتی</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> جاری شرکا پرداختنی</span>
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn icon fab color="white" class="mt-1 ml-2" @click="closeDialog('person')">
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="p"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="r"></accounts>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <accounts :is-dialog="true" level="3" account-type="a"></accounts>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="warehouseDialog"
        class="rounded-lg"
        persistent
        max-width="90%"
    >
      <v-card class="rounded-lg">
        <v-card-text>
          <v-tabs class="rounded-lg white--text"
                  background-color="lightSecondary" color="primary">
            <v-tab class="white--text mr-2" active-class="secondary mr-2">
              <span> تعریف انبار</span>
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn icon fab color="white" class="mt-1 ml-2" @click="closeDialog('warehouse')">
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-tab-item class="pt-1">
              <warehouses :is-dialog="true"></warehouses>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="wareDialog"
        class="rounded-lg"
        persistent
        max-width="90%"
    >
      <v-card class="rounded-lg">
        <v-card-text>
          <v-tabs class="rounded-lg white--text"
                  background-color="lightSecondary" color="primary">
            <v-tab class="white--text mr-2" active-class="secondary mr-2">
              <span> ماهیت</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> گروه</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> دسته بندی</span>
            </v-tab>
            <v-tab class="white--text " active-class="secondary">
              <span> کالا</span>
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn icon fab color="white" class="mt-1 ml-2" @click="closeDialog('ware')">
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-tab-item class="pt-1">
              <wares :is-dialog="true" level="0"></wares>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <wares :is-dialog="true" level="1"></wares>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <wares :is-dialog="true" level="2"></wares>
            </v-tab-item>
            <v-tab-item class="pt-1">
              <wares :is-dialog="true" level="3"></wares>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import Warehouses from "@/views/panel/ware/Warehouses";
import Wares from '@/views/panel/ware/Wares.vue';
import Accounts from '@/views/panel/account/Accounts.vue';

export default {
  name: 'Wizard',
  components: {Warehouses, Wares, Accounts},
  mixins: [],
  props: {},
  data() {
    return {
      wareDialog: false,
      warehouseDialog: false,
      bankDialog: false,
      personDialog: false,
      wizardDialog: false,
      firstStep: false,
      secondStep: false,
      thirdStep: false,
      fourthStep: false,
      settingUpFinancialYearDialog: true,
    };
  },
  mounted() {
  },
  methods: {
    closeDialog(dialog){
      this.request({
        url: this.endpoint("users/currentUser/"),
        method: "get",
        success: data => {
          this.$store.commit("setUser", data);
        },
      });

      if (dialog == 'person') {
        this.personDialog = false
      } else if (dialog == 'bank') {
        this.bankDialog = false
      }  else {
        this.wareDialog = false
        this.warehouseDialog = false
      }

    }

  },
};
</script>
<style lang="scss">
.cursor-pointer {
  cursor: pointer !important;
}
</style>